<drawer [title]="'Services'"
        [contextLabel]="selectedClassificationType?.name"
        [contextVariant]="'neutral'"
        [isClosed]="isDrawerClosed" [showHeaderButtons]="false">
    <div class="row d-flex align-items-center py-1 list-search-container-zone">
        <div class="col">
            <div class="list-search-container">
                <i class="fas fa-search list-search-icon"></i>
                <form class="list-search-form align-items-center">
                    <input
                        placeholder="{{ 'Search' | translate }}"
                        class="list-search-input"
                        (click)="$event.stopPropagation()"
                        (input)="searchServiceChanged($event.target.value)"
                        [(ngModel)]="searchService"
                        type="text"
                        name="searchService"
                        />
                        <i
                        *ngIf="searchServiceFilterObject"
                        (click)="resetServiceSearch()"
                        class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                        aria-hidden="true"
                      ></i>
                </form>
            </div>
        </div>
        <div class="col-auto pr-0">
            <i (click)="toggleAllUsedService();" class="{{areAllUsedServices ? '' : 'fa-flip-horizontal toggle-disabled'}} fa-toggle-large-on fas toggle-primary toggle__icon mt-1"></i>
        </div>
        <div class="col-auto">
            {{'Toggle all' | translate}}
        </div>
    </div>
    <div class="list-search-options-zone">
        <ng-container *ngFor="let usedService of usedServices | filterBy: searchServiceFilterObject;">
            <div class="row d-flex align-items-center py-1">
                <div class="col-auto pr-0 pl-3">
                    <i (click)="toggleUsedService(usedService)" class="{{usedService.isActive ? '' : 'fa-flip-horizontal toggle-disabled'}} fa-toggle-large-on fas toggle-primary toggle__icon mt-1"></i>
                </div>
                <div class="col">
                    {{usedService.name}}
                </div>
            </div>
        </ng-container>
    </div>
</drawer>
<drawer [title]="'Upload items'"
        [contextLabel]="selectedClassificationType?.name"
        [contextVariant]="'info'"
        [isClosed]="isImportDrawerClosed" [showHeaderButtons]="false" (closeEvent)="isImportDrawerClosed = true">
    <div class="drawer-content drawer-direct-content mt-4">
        <div class="row d-flex align-items-center py-1">
            <div class="col">
                <b class="mb-3 d-block">{{'You can upload catalogs together with subcatalogs, but Before uploading items from file:' | translate}}</b>
            </div>
        </div>
        <div class="row py-1">
            <div class="col">
                <p>{{'Please note those consideration'}}</p>
                <ul class="mb-3">
                    <li class="mb-1 alert alert-primary">{{'Headers should not be included in the file' | translate}}</li>
                    <li class="mb-1 alert alert-primary">{{"First level doesn't have parent (cf template files)" | translate}}</li>
                    <li class="mb-1 alert alert-primary">{{'Item order matters' | translate}}</li>
                    <li class="mb-1 alert alert-primary">{{'Translations are not supported yet' | translate}}</li>
                    <li class="mb-1 alert alert-primary">{{'Before importing with custom keys, please enable Use custom keys toggle button' | translate}}</li>
                </ul>
                <div class="d-flex justify-content-between mb-4">
                    <label class="btn btn-slightly-darker btn-rounded btn-md text-uppercase">
                        <input type="file" class="hidden" (change)="onFileChange($event); isImportDrawerClosed = true;"
                            multiple="false" />
                        {{'Import simple catalog' | translate}}
                    </label>
                    <a class="upload-button file-input-wrapper btn btn-md btn-primary font-16 text-uppercase"
                        (click)="importCSVFile($event); isImportDrawerClosed = true;">
                        {{'Import catalog with sub-catalogs' | translate}}
                    </a>
                </div>
            </div>
            <div class="col">
                <p>{{'Have a look at those templates'}}</p>
                <a class="btn btn-md btn-outline-primary text-uppercase text-button--primary d-inline-block mb-2"
                    href="assets/example_catalogue.xlsx">{{'Simple catalog tempate' | translate}}</a><br>
                <a class="btn btn-md btn-outline-primary text-uppercase text-button--primary d-inline-block mb-2"
                    href="assets/Import-Catalog-Custom-Key.xlsx">{{'Import catalog template with custom keys' | translate}}</a><br>
                <a class="btn btn-md btn-outline-primary text-uppercase text-button--primary d-inline-block"
                    href="assets/Import-Catalog-no-custom-Key.xlsx">{{'Import catalog template without custom keys' | translate}}</a>
            </div>
        </div>
    </div>
</drawer>
<drawer [title]="isRejectionCatalogs ? 'New rejection reason' : 'New catalog'"
    [contextLabel]="selectedClassificationType?.name"
    [contextVariant]="isRejectionCatalogs ? 'warning' : 'info'"
    [isClosed]="isAddNewCatalogClosed"
    (saveEvent)="saveNewClassification();"
    (closeEvent)="cancelNewClassification()">
    <div class="row drawer-content">
        <div class="col">
            <div class="row fields-group mt-4">
                <div class="col">
                    <label for="newName" class="input-label field-required">{{'Catalog name' | translate}}</label>
                    <input type="text" class="form-control mt-2" id="newName" [(ngModel)]="newClassificationName" required>
                </div>
              </div>
        </div>
    </div>
</drawer>

<drawer [title]="'Catalog usages' | translate"
        [contextLabel]="selectedCatalogForUsages?.name"
        [contextVariant]="'neutral'"
        [isClosed]="!showUsagesDrawer"
        [showHeaderButtons]="false"
        (closeEvent)="closeUsagesDrawer()"
        [noContentPadding]="true">
    <div class="drawer-content drawer-direct-content p-3">
        <!-- Loading state -->
        <div *ngIf="loadingUsages" class="d-flex justify-content-center my-5">
            <i class="fad fa-spinner-third fa-spin align-self-center fa-2x"></i>
        </div>
        <!-- Usages display grouped by type -->
        <ng-container *ngIf="!loadingUsages">
            <!-- Empty state -->
            <div *ngIf="catalogUsages.length === 0" class="text-center text-muted py-5">
                <i class="fal fa-box-open fa-3x mb-3"></i>
                <p>{{ 'No usages found' | translate }}</p>
            </div>

            <!-- Group by Service -->
            <div *ngFor="let service of groupedUsages" class="row fields-group">
                <div class="col d-flex flex-column">
                    <!-- Service header -->
                    <div class="row fields-group-header fields-group-header-collapsible flex-shrink-1"
                         (click)="toggleUsagesSection('service-' + service.serviceId)"
                         [ngClass]="{'expanded': isUsagesSectionOpen('service-' + service.serviceId)}">
                        <div class="col justify-content-between d-flex">
                            <label class="input-label mb-0">
                                <i class="far fa-circle-nodes mr-2"></i>
                                {{ getServiceName(service.serviceId) }}
                                <span class="badge badge-light ml-2">{{ getServiceUsagesCount(service) }}</span>
                            </label>
                            <i class="fas ml-auto mt-1"
                               [ngClass]="{'fa-chevron-down': !isUsagesSectionOpen('service-' + service.serviceId), 'fa-chevron-up': isUsagesSectionOpen('service-' + service.serviceId)}"></i>
                        </div>
                    </div>

                    <!-- Service content -->
                    <ng-container *ngIf="isUsagesSectionOpen('service-' + service.serviceId)">
                        <div class="row fields-group-content flex-grow-1">
                            <div class="col">
                                <!-- Forms grouped by form -->
                                <div *ngIf="service.forms.length > 0" class="mb-2">
                                    <div class="d-flex align-items-start justify-content-between cursor-pointer py-2 border-bottom"
                                         (click)="toggleUsagesSection('forms-' + service.serviceId)">
                                        <span class="text-body small font-weight-bold">
                                            <i class="far fa-file mr-2"></i>{{ 'Forms' | translate }}
                                            <span class="badge badge-light ml-2">{{ getFormsUsagesCount(service.forms) }}</span>
                                        </span>
                                        <i class="fas text-muted"
                                           [ngClass]="{'fa-chevron-up': isUsagesSectionOpen('forms-' + service.serviceId), 'fa-chevron-down': !isUsagesSectionOpen('forms-' + service.serviceId)}"></i>
                                    </div>
                                    <div *ngIf="isUsagesSectionOpen('forms-' + service.serviceId)" class="pt-2">
                                        <div *ngFor="let form of service.forms" class="mb-3">
                                            <div class="mb-2">
                                                <span class="badge badge-primary">{{ form.formType }}</span>
                                            </div>
                                            <div class="table-items text-left">
                                                <div *ngFor="let usage of form.usages" class="item">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div class="d-flex align-items-center">
                                                            <i class="far fa-key text-muted mr-2"></i>
                                                            <span>{{ usage.componentKey }}</span>
                                                        </div>
                                                        <i *ngIf="getUsageRouteUrl(usage)"
                                                           class="far fa-external-link text-primary cursor-pointer usage-link ml-2"
                                                           (click)="openUsageInNewTab(usage); $event.stopPropagation()"
                                                           [title]="'Open in new tab' | translate"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Determinants -->
                                <div *ngIf="service.determinants.length > 0" class="mb-2">
                                    <div class="d-flex align-items-start justify-content-between cursor-pointer py-2 border-bottom"
                                         (click)="toggleUsagesSection('dets-' + service.serviceId)">
                                        <span class="text-body small font-weight-bold">
                                            <i class="far fa-sliders-h mr-2"></i>{{ 'Determinants' | translate }}
                                            <span class="badge badge-light ml-2">{{ service.determinants.length }}</span>
                                        </span>
                                        <i class="fas text-muted"
                                           [ngClass]="{'fa-chevron-up': isUsagesSectionOpen('dets-' + service.serviceId), 'fa-chevron-down': !isUsagesSectionOpen('dets-' + service.serviceId)}"></i>
                                    </div>
                                    <div *ngIf="isUsagesSectionOpen('dets-' + service.serviceId)" class="pt-2">
                                        <div class="table-items text-left">
                                            <div *ngFor="let usage of service.determinants" class="item">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <i class="far fa-sliders-h text-muted mr-2"></i>
                                                        <span>{{ usage.determinantName }}</span>
                                                    </div>
                                                    <i *ngIf="getUsageRouteUrl(usage)"
                                                       class="far fa-external-link text-primary cursor-pointer usage-link ml-2"
                                                       (click)="openUsageInNewTab(usage); $event.stopPropagation()"
                                                       [title]="'Open in new tab' | translate"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Parent Catalogs -->
                                <div *ngIf="service.parentCatalogs.length > 0" class="mb-2">
                                    <div class="d-flex align-items-start justify-content-between cursor-pointer py-2 border-bottom"
                                         (click)="toggleUsagesSection('parents-' + service.serviceId)">
                                        <span class="text-body small font-weight-bold">
                                            <i class="far fa-sitemap mr-2"></i>{{ 'Parent catalogs' | translate }}
                                            <span class="badge badge-light ml-2">{{ service.parentCatalogs.length }}</span>
                                        </span>
                                        <i class="fas text-muted"
                                           [ngClass]="{'fa-chevron-up': isUsagesSectionOpen('parents-' + service.serviceId), 'fa-chevron-down': !isUsagesSectionOpen('parents-' + service.serviceId)}"></i>
                                    </div>
                                    <div *ngIf="isUsagesSectionOpen('parents-' + service.serviceId)" class="pt-2">
                                        <div class="table-items text-left">
                                            <div *ngFor="let usage of service.parentCatalogs" class="item">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <i class="far fa-sitemap text-muted mr-2"></i>
                                                        <span>{{ usage.parentCatalogName }}</span>
                                                        <span *ngIf="usage.parentCatalogFieldName" class="text-muted ml-2">
                                                            <i class="far fa-arrow-right mx-1"></i>{{ usage.parentCatalogFieldName }}
                                                        </span>
                                                    </div>
                                                    <i *ngIf="getUsageRouteUrl(usage)"
                                                       class="far fa-external-link text-primary cursor-pointer usage-link ml-2"
                                                       (click)="openUsageInNewTab(usage); $event.stopPropagation()"
                                                       [title]="'Open in new tab' | translate"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</drawer>

<div class="row w-100 m-0 position-relative">
    <app-list-grid *ngIf="!hideList" class="col-md-12" [items]="filteredClassificationTypes"
                   [inlineAdd]=false [sortable]=false [listToggle]=false [expanded]=true [defaultSortKey]="'name'"
                   [defaultSortKeyType]="'string'" [addText]="'Add'" [navigationEdit]=false
                   [newItem]="newClassification" [selectAll]=true [determinantMapById]="determinantMapById"
                   (createFunction)="createClassificationType($event)"
                   [counterLabel]="'Items'"
                   (editFunction)="loadEditClassificationType($event)"
                   (deleteFunction)="deleteClassificationType($event)" [hasFilters]="false"
                   [hasPagination]="true" [page]="page" [pageSize]="pageSize" [totalPages]="totalPages" (updatePage)="updatePage($event)"
                   [multipleSelect]="true" [hasFieldNumber]="true" [hasUsagesColumn]="true" (toggleFilter)="toggleFilters($event)"
                   (usagesClick)="openCatalogUsages($event)">
    </app-list-grid>
</div>

<div *ngIf="hideList" class="px-3 py-3">

    <div class="row mb-3">
        <div class="col-12">
            <div class="d-inline-flex">
                <ul class="d-flex nav nav-pill nav-tabs styleguide-tabs text-center my-1">
                    <li class="mr-3 nav-item">
                        <a class="nav-link cursor-pointer" (click)="goToBackList();">
                            <i class="fas fa-angle-left mr-2"></i>
                            {{'Back to list' | translate}}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div class="row fields-group">
        <div class="col">
                <label class="input-label w-100 d-flex justify-content-end flex-row align-items-center flex-wrap">
                    <span class="d-inline-block">{{'Name' | translate}}</span>

                    <div class="ml-auto dropdown align-self-center dropdown p-0"
                        dropdown placement="left-top">
                        <button class="btn btn-ghost btn-sm" dropdownToggle>
                            <i class="fa-regular fa-ellipsis-vertical mr-2"></i>
                            {{ "Catalog options" | translate }}
                        </button>
                        <div class="dropdown-menu dropdown-menu-left-outside" *dropdownMenu>
                            <div class="dropdown-item btn-default" *ngIf="selectedClassificationType.businessKey">
                                <business-key
                                    [businessKey]="selectedClassificationType.businessKey"
                                    [fullButton]="true"
                                    [businessKeyTooltip]="'Catalog items business key' | translate"
                                    [extraClass]="'service-context-menu-item'">
                                </business-key>
                            </div>
                            <div class="dropdown-item">
                                <a
                                    href="#"
                                    class="service-context-menu-item"
                                    (click)="copyClassification(); $event.preventDefault();"
                                >
                                    <i class="far text-gray fa-copy"></i>
                                    {{'classification.other.copy' | translate}}
                                </a>
                            </div>
                            <div class="dropdown-item">
                                <a
                                    href="#"
                                    class="service-context-menu-item"
                                    (click)="isImportDrawerClosed = false; $event.preventDefault();"
                                >
                                    <i class="far text-gray fa-upload"></i>
                                    {{'Upload catalog' | translate}}
                                </a>
                            </div>
                            <div class="dropdown-item">
                                <a
                                    href="#"
                                    class="service-context-menu-item"
                                    (click)="exportToCSV(); $event.preventDefault();"
                                >
                                    <i class="far text-gray fa-file-csv"></i>
                                    {{'Export to CSV' | translate}}
                                </a>
                            </div>
                            <div class="dropdown-divider m-0"></div>
                            <div class="dropdown-item px-3" *ngIf="!isRejectionCatalogs">
                                <toggle-switch
                                    [containerClass]="'service-context-menu-item'"
                                    [toggled]="selectedClassificationType.useInConstants"
                                    (toggledChange)="selectedClassificationType.useInConstants = $event; saveClassificationType(true)"
                                    [label]="'classification.other.use_in_constants' | translate"
                                ></toggle-switch>
                            </div>
                        </div>
                    </div>
                    <!--
                    <span class="mr-2">
                        <i id="showInForm"
                        class="fas {{selectedClassificationType && selectedClassificationType.classificationOnForm ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                        (click)="selectedClassificationType.classificationOnForm = !selectedClassificationType.classificationOnForm; saveClassificationType(true)"
                        style="vertical-align: middle;"></i>
                        <label for="showInForm" class="font-weight-normal" style="font-size:0.8rem; color:#777;">
                            {{'classification.other.show_in_form_builder' | translate}}
                        </label>
                    </span>
                    -->

                </label>
                <input (focusout)="editClassificationType();" class="form-control" type="text"
                    [(ngModel)]="selectedClassificationType.name" name="name" #name="ngModel" [rangeLength]="[2, 256]"
                    required>
                <p class="validation-error" *ngIf="name.errors?.required && name?.touched">
                    {{ 'form.validate.required' | translate }}</p>
                <p class="validation-error" *ngIf="name.errors?.rangeLength">{{ 'form.validate.minLenght' | translate }} 2!
                </p>
                <p class="validation-error" *ngIf="name.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }}
                    256!</p>
            </div>
    </div>

    <i class="go-to-top fas fa-arrow-to-top" (click)="scrollToTop();"></i>


    <tabset type="tabs" class="pill catalog-tabs">
        <tab>
            <ng-template tabHeading>
                {{ 'classification.other.items' | translate }} ({{fieldsAllItems}})
            </ng-template>
            <div class="row mb-3">
                <div class="col-12">
                    <div class="list-search-container">
                        <i class="fas fa-search list-search-icon"></i>
                        <input class="form-control list-search-input" type="text"
                            placeholder="{{ 'Search items' | translate }}"
                            [(ngModel)]="catPageFilter"
                            (keyup)="onFilterChange()">
                        <i *ngIf="catPageFilter" (click)="clearFilter()"
                            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"></i>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 table-responsive">
                    <table datatable class="table align-middle effects-table">
                        <thead>
                            <tr>
                                <th *ngIf="selectedClassificationType.useCustomOrder" class="text-center cell-order"></th>
                                <th class="text-left" [style.width]="isRejectionCatalogs ? 'auto' : '35%'">
                                    <div class="d-flex align-items-center">
                                        <i *ngIf="lastOrder" class="fas fa-times btn-xs btn-bordered btn-danger btn-icon" (click)="revertSort()"></i> <span (click)="sortItems('value')" class="cursor-pointer"><i class="fas fa-sort"></i> {{'classification.other.items' | translate}}</span>
                                        <i class="ml-auto px-2 fas align-middle {{selectedClassificationType.useCustomKey ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}"
                                            id="useCustomKey"
                                            *ngIf="!isRejectionCatalogs"
                                            (click)="selectedClassificationType.useCustomKey = !selectedClassificationType.useCustomKey; saveClassificationType(true)"></i>
                                        <label *ngIf="!isRejectionCatalogs" for="useCustomKey" class="font-weight-normal"
                                            style="font-size:0.8rem; color:#777;">
                                            {{'classification.other.use_custom_key' | translate}}
                                        </label>
                                    </div>
                                </th>
                                <th *ngIf="selectedClassificationType.useCustomKey" class="text-left"
                                    style="width: 336px">
                                    <i *ngIf="lastOrder" class="fas fa-times btn-xs btn-bordered btn-danger btn-icon" (click)="revertSort()"></i> <span (click)="sortItems('key')" class="cursor-pointer"><i class="fas fa-sort"></i> {{'classification.other.key' | translate}}</span>
                                    <span class="float-right">
                                        <a class="btn btn-md btn-outline-primary text-uppercase text-button--primary"
                                            style="margin-inline-start:1rem;" (click)="generateCustomKeys();">
                                            {{'Generate keys' | translate}}
                                        </a>
                                    </span>
                                </th>
                                <th class="text-left" [style.width]="isRejectionCatalogs ? 'auto' : '356px'">
                                    <span *ngIf="!isRejectionCatalogs">{{'classification.other.sub_classificators' | translate}}</span>
                                    <span *ngIf="isRejectionCatalogs">{{'Explanation text' | translate}}</span>
                                </th>
                                <th class="text-center cell-delete">&nbsp;</th>
                            </tr>
                            <tr class="separator-header">
                                <th *ngIf="selectedClassificationType.useCustomKey"></th>
                                <th *ngIf="selectedClassificationType.useCustomOrder"></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody id="fieldsList"
                            cdkDropList
                            [cdkDropListData]="classificationFields"
                            (cdkDropListDropped)="dropped($event)">
                            <ng-container *ngFor="let row of classificationFields; let i = index; trackBy:trackByFn">
                                <tr class="separator-row">
                                    <td *ngIf="selectedClassificationType.useCustomOrder"></td>
                                    <td *ngIf="selectedClassificationType.useCustomKey"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr cdkDrag id="field-{{row.id}}">
                                    <td *ngIf="selectedClassificationType.useCustomOrder" class="text-center align-middle handlers-cell">
                                        <i *ngIf="i > 0" class="fas fa-arrow-to-top handle-to-top" tooltip="{{'Move to top' | translate}}" style="font-size:0.8rem" (click)="moveToTop(row)"></i>
                                        <i *ngIf="i < classificationFields.length - 1" class="fas fa-arrow-to-bottom handle-to-bottom" tooltip="{{'Move to bottom' | translate}}" style="font-size:0.8rem" (click)="moveToBottom(row)"></i>
                                        <i cdkDragHandle class="fa-solid fa-grip-dots handle mx-1" style="font-size:0.8rem" [class.text-muted]="catPageFilter" [class.cursor-not-allowed]="catPageFilter" [tooltip]="catPageFilter ? ('Clear the search filter before reordering items' | translate) : ''"></i>
                                    </td>
                                    <td>
                                        <input name="value" class="form-control" type="text" [(ngModel)]="row.value"
                                            (focusout)="updateClassificationField(row);" required>
                                    </td>
                                    <td *ngIf="selectedClassificationType.useCustomKey">
                                        <input name="key" class="form-control {{ !row.key ? 'is-invalid' : ''}} " type="text" [(ngModel)]="row.key"
                                            (focusout)="updateClassificationField(row);">
                                    </td>
                                    <td class="align-middle">
                                        <div *ngIf="!(row.childClassificationType || row.selectOpened) && !isRejectionCatalogs"
                                            style="position:relative;top:1px">
                                            <primary-text-button (onClick)="row.selectOpened = true" [noRightMargin]=true>
                                                {{'Select' | translate}}
                                            </primary-text-button>
                                        </div>
                                        <ng-select *ngIf="(row.childClassificationType || row.selectOpened) && !isRejectionCatalogs"
                                        class="custom form-control"
                                        bindLabel="name"
                                        bindValue="id"
                                        [items]="classificationTypesWithoutCurrent"
                                        [ngModel]="row.childClassificationType?.id"
                                        (search)="searchSubCatalogs($event)"
                                        (scrollToEnd)="scrollNextPage()"
                                        placeholder="{{'Type subcatalog name to search' | translate}}"
                                        (change)="selectedSubClassification(row, $event)"></ng-select>
                                        <div *ngIf="isRejectionCatalogs" class="d-flex align-items-center">
                                            <i class="px-2 fas align-middle {{row.sayRejectionReason ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}"
                                                (click)="row.sayRejectionReason = !row.sayRejectionReason; updateClassificationField(row);"></i>
                                        </div>
                                    </td>
                                    <td class="text-center opts-cell">
                                        <div class="d-flex text-right align-items-center justify-content-end mr-2">
                                            <a *ngIf="row.childClassificationType" tooltip="{{ 'general.open' | translate }}" href="variables/instance-catalogs/{{ row.childClassificationType.id }}" target="_blank" class="btn-circle-icon btn-circle-small btn-purple mr-2">
                                                <i class="far fa-paperclip"></i>
                                            </a>
                                            <business-key *ngIf="row.businessKey"
                                                class="ml-auto d-inline-flex align-self-center mr-2"
                                                [businessKey]="row.businessKey"
                                                [businessKeyTooltip]="'Catalog items business key' | translate"></business-key>
                                            <confirmation [showTrashIcon]="true" [question]="'confirm.areyousure'"
                                                *ngIf="filterUndeletableItems(selectedClassificationType, row)"
                                                (isConfirmed)="removeClassificationField($event, row.id);">
                                            </confirmation>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        <!--
                            <tr>
                                <td *ngIf="selectedClassificationType.useCustomOrder"></td>
                                <td class="pt-4" [colSpan]="selectedClassificationType.useCustomKey ? '4' : '3'">
                                    <button class="upload-button file-input-wrapper editBtn font-9" (click)="isImportDrawerClosed = false;">
                                        {{'Upload catalog' | translate}}
                                    </button>
                                </td>
                            </tr>
                        -->
                        </tbody>
                        <tfoot>
                            <tr class="separator-row">
                                <td *ngIf="selectedClassificationType.useCustomOrder"></td>
                                <td *ngIf="selectedClassificationType.useCustomKey"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr class="add-item-row">
                                <td *ngIf="selectedClassificationType.useCustomOrder" class="text-center align-middle">
                                </td>
                                <td class="pl-0">
                                    <input class="form-control" type="text"
                                        placeholder="{{ 'Add new item' | translate }}"
                                        [(ngModel)]="newItemValue"
                                        (keyup.enter)="addNewClassificationField()">
                                </td>
                                <td *ngIf="selectedClassificationType.useCustomKey"></td>
                                <td class="text-start align-middle">
                                    <button class="btn btn-sm btn-primary" (click)="addNewClassificationField()" [disabled]="!newItemValue || newItemValue.length === 0">{{'Add' | translate }}</button>
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="app-pagination d-flex align-items-center justify-content-between"
                 *ngIf="fieldsAllItems > pageSizeOptions[0]">
                <span class="text-muted small">
                    {{ 'Rows per page:' | translate }}
                    <select style="border: none; background: transparent; color: inherit; font: inherit; cursor: pointer; padding: 2px 0; outline: none;"
                            [(ngModel)]="fieldsPageSize"
                            (ngModelChange)="onPageSizeChange()">
                        <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt">{{opt}}</option>
                        <option [ngValue]="PAGE_SIZE_ALL">{{ 'All' | translate }}</option>
                    </select>
                </span>
                <ul class="pagination mb-0" *ngIf="fieldsAllItems > fieldsPageSize">
                    <li class="page-item" *ngIf="fieldsPage > 1">
                        <a class="page-link" (click)="goToPage(1)">
                            <i class="fal fa-angle-double-left"></i>
                        </a>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage > 1">
                        <a class="page-link" (click)="goToPage(fieldsPage - 1)">
                            <i class="fal fa-angle-left"></i>
                        </a>
                    </li>
                    <li
                        *ngFor="let p of getPageNumber()"
                        class="page-item"
                        [ngClass]="{'hidden': (p !== fieldsPage)}">
                        <span class="page-link disabled" disabled>
                        <b>{{p}}</b> of {{getPageNumber()[(getPageNumber().length - 1)]}}
                        </span>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage <= (getPageNumber().length-1)">
                        <a class="page-link" (click)="goToPage(fieldsPage + 1)">
                            <i class="fal fa-angle-right"></i>
                        </a>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage <= getPageNumber()[(getPageNumber().length - 2)]">
                        <a class="page-link" (click)="goToPage(getPageNumber()[(getPageNumber().length - 1)])">
                            <i class="fal fa-angle-double-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </tab>
        <tab (selectTab)="onUsagesTabSelected()">
            <ng-template tabHeading>
                {{ 'Usages' | translate }}
                <span *ngIf="!loadingUsages">({{ getTotalUsagesCount() }})</span>
                <i *ngIf="loadingUsages" class="fad fa-spinner-third fa-spin ml-1"></i>
            </ng-template>
            <div class="py-3">
                <!-- Loading state -->
                <div *ngIf="loadingUsages" class="d-flex justify-content-center my-5">
                    <i class="fad fa-spinner-third fa-spin align-self-center fa-2x"></i>
                </div>

                <ng-container *ngIf="!loadingUsages">
                    <!-- Empty state -->
                    <div *ngIf="catalogUsages.length === 0" class="text-center text-muted py-5">
                        <i class="fal fa-box-open fa-3x mb-3"></i>
                        <p>{{ 'No usages found' | translate }}</p>
                    </div>

                    <!-- Group by Service -->
                    <div *ngFor="let service of groupedUsages" class="row fields-group">
                        <div class="col d-flex flex-column">
                            <!-- Service header -->
                            <div class="row fields-group-header fields-group-header-collapsible flex-shrink-1"
                                 (click)="toggleUsagesSection('detail-service-' + service.serviceId)"
                                 [ngClass]="{'expanded': isUsagesSectionOpen('detail-service-' + service.serviceId)}">
                                <div class="col justify-content-between d-flex">
                                    <label class="input-label mb-0">
                                        <i class="far fa-circle-nodes mr-2"></i>
                                        {{ getServiceName(service.serviceId) }}
                                        <span class="badge badge-light ml-2">{{ getServiceUsagesCount(service) }}</span>
                                    </label>
                                    <i class="fas ml-auto mt-1"
                                       [ngClass]="{'fa-chevron-down': !isUsagesSectionOpen('detail-service-' + service.serviceId), 'fa-chevron-up': isUsagesSectionOpen('detail-service-' + service.serviceId)}"></i>
                                </div>
                            </div>

                            <!-- Service content -->
                            <ng-container *ngIf="isUsagesSectionOpen('detail-service-' + service.serviceId)">
                                <div class="row fields-group-content flex-grow-1">
                                    <div class="col">
                                        <!-- Forms grouped by form -->
                                        <div *ngIf="service.forms.length > 0" class="mb-2">
                                            <div class="d-flex align-items-start justify-content-between cursor-pointer py-2 border-bottom"
                                                 (click)="toggleUsagesSection('detail-forms-' + service.serviceId)">
                                                <span class="text-body small font-weight-bold">
                                                    <i class="far fa-file mr-2"></i>{{ 'Forms' | translate }}
                                                    <span class="badge badge-light ml-2">{{ getFormsUsagesCount(service.forms) }}</span>
                                                </span>
                                                <i class="fas text-muted"
                                                   [ngClass]="{'fa-chevron-up': isUsagesSectionOpen('detail-forms-' + service.serviceId), 'fa-chevron-down': !isUsagesSectionOpen('detail-forms-' + service.serviceId)}"></i>
                                            </div>
                                            <div *ngIf="isUsagesSectionOpen('detail-forms-' + service.serviceId)" class="pt-2">
                                                <div *ngFor="let form of service.forms" class="mb-3">
                                                    <div class="mb-2">
                                                        <span class="badge badge-primary">{{ form.formType }}</span>
                                                    </div>
                                                    <div class="table-items text-left">
                                                        <div *ngFor="let usage of form.usages" class="item">
                                                            <div class="d-flex align-items-center justify-content-between">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="far fa-key text-muted mr-2"></i>
                                                                    <span>{{ usage.componentKey }}</span>
                                                                </div>
                                                                <i *ngIf="getUsageRouteUrl(usage)"
                                                                   class="far fa-external-link text-primary cursor-pointer usage-link ml-2"
                                                                   (click)="openUsageInNewTab(usage); $event.stopPropagation()"
                                                                   [title]="'Open in new tab' | translate"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Determinants -->
                                        <div *ngIf="service.determinants.length > 0" class="mb-2">
                                            <div class="d-flex align-items-start justify-content-between cursor-pointer py-2 border-bottom"
                                                 (click)="toggleUsagesSection('detail-dets-' + service.serviceId)">
                                                <span class="text-body small font-weight-bold">
                                                    <i class="far fa-sliders-h mr-2"></i>{{ 'Determinants' | translate }}
                                                    <span class="badge badge-light ml-2">{{ service.determinants.length }}</span>
                                                </span>
                                                <i class="fas text-muted"
                                                   [ngClass]="{'fa-chevron-up': isUsagesSectionOpen('detail-dets-' + service.serviceId), 'fa-chevron-down': !isUsagesSectionOpen('detail-dets-' + service.serviceId)}"></i>
                                            </div>
                                            <div *ngIf="isUsagesSectionOpen('detail-dets-' + service.serviceId)" class="pt-2">
                                                <div class="table-items text-left">
                                                    <div *ngFor="let usage of service.determinants" class="item">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <div class="d-flex align-items-center">
                                                                <i class="far fa-sliders-h text-muted mr-2"></i>
                                                                <span>{{ usage.determinantName }}</span>
                                                            </div>
                                                            <i *ngIf="getUsageRouteUrl(usage)"
                                                               class="far fa-external-link text-primary cursor-pointer usage-link ml-2"
                                                               (click)="openUsageInNewTab(usage); $event.stopPropagation()"
                                                               [title]="'Open in new tab' | translate"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Parent Catalogs -->
                                        <div *ngIf="service.parentCatalogs.length > 0" class="mb-2">
                                            <div class="d-flex align-items-start justify-content-between cursor-pointer py-2 border-bottom"
                                                 (click)="toggleUsagesSection('detail-parents-' + service.serviceId)">
                                                <span class="text-body small font-weight-bold">
                                                    <i class="far fa-sitemap mr-2"></i>{{ 'Parent catalogs' | translate }}
                                                    <span class="badge badge-light ml-2">{{ service.parentCatalogs.length }}</span>
                                                </span>
                                                <i class="fas text-muted"
                                                   [ngClass]="{'fa-chevron-up': isUsagesSectionOpen('detail-parents-' + service.serviceId), 'fa-chevron-down': !isUsagesSectionOpen('detail-parents-' + service.serviceId)}"></i>
                                            </div>
                                            <div *ngIf="isUsagesSectionOpen('detail-parents-' + service.serviceId)" class="pt-2">
                                                <div class="table-items text-left">
                                                    <div *ngFor="let usage of service.parentCatalogs" class="item">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <div class="d-flex align-items-center">
                                                                <i class="far fa-sitemap text-muted mr-2"></i>
                                                                <span>{{ usage.parentCatalogName }}</span>
                                                                <span *ngIf="usage.parentCatalogFieldName" class="text-muted ml-2">
                                                                    <i class="far fa-arrow-right mx-1"></i>{{ usage.parentCatalogFieldName }}
                                                                </span>
                                                            </div>
                                                            <i *ngIf="getUsageRouteUrl(usage)"
                                                               class="far fa-external-link text-primary cursor-pointer usage-link ml-2"
                                                               (click)="openUsageInNewTab(usage); $event.stopPropagation()"
                                                               [title]="'Open in new tab' | translate"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </tab>
        <tab *ngIf="!isRejectionCatalogs" (selectTab)="onGroupsTabSelected()">
            <ng-template tabHeading>
                {{ 'classification.other.groups' | translate }} ({{groups?.length}})
            </ng-template>
            <div class="row">
                <div class="col-5 pr-0">
                    <div class="list-search-container">
                        <i class="fas fa-search list-search-icon"></i>
                        <input class="form-control list-search-input" type="text"
                            placeholder="{{ 'Search items' | translate }}"
                            [(ngModel)]="searchValue">
                        <i *ngIf="searchValue" (click)="searchValue = ''"
                            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"></i>
                    </div>
                </div>
                <div class="col-3 pr-0">
                    <div class="list-search-container">
                        <input class="form-control list-search-input" type="text" [(ngModel)]="groupValue" placeholder="{{ 'Group name' | translate }}">
                        <a (click)="addNewClassificationGroup()"
                            class="btn btn-sm btn-primary mr-1 {{ groupValue && groupValue.length >= 1 ? '' : 'disabled' }}">{{'Add' | translate }}</a>
                    </div>
                </div>
                <div class="col-4 d-flex align-items-center">
                    <div class="ml-auto dropdown align-self-center dropdown p-0"
                        dropdown placement="top">
                        <button class="btn btn-ghost btn-sm" dropdownToggle>
                            <i class="fa-regular fa-ellipsis-vertical mr-2"></i>
                            {{ "Groups options" | translate }}
                        </button>
                        <div class="dropdown-menu dropdown-menu-left-outside" *dropdownMenu>
                            <div class="dropdown-item px-3">
                                <toggle-switch
                                    [containerClass]="'service-context-menu-item'"
                                    [toggled]="selectedClassificationType.useGroupsForSubCatalogs"
                                    (toggledChange)="selectedClassificationType.useGroupsForSubCatalogs = $event; saveClassificationType(true)"
                                    [label]="'Propagate to subcatalogs' | translate"
                                ></toggle-switch>
                            </div>
                            <div class="dropdown-item px-3">
                                <toggle-switch
                                    [containerClass]="'service-context-menu-item'"
                                    [toggled]="selectedClassificationType.showGroups"
                                    (toggledChange)="selectedClassificationType.showGroups = $event; saveClassificationType(true)"
                                    [label]="'Show groups in selects' | translate"
                                ></toggle-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <!-- Loading indicator for Groups tab -->
                    <div *ngIf="isLoadingAllFields" class="text-center py-4">
                        <i class="fal fa-spinner-third fa-spin fa-2x text-primary"></i>
                        <p class="mt-2 text-muted">{{ 'Loading all catalog items...' | translate }}</p>
                    </div>
                    <section class="scrollable-table-container" *ngIf="!isLoadingAllFields">
                        <section id="groupTable" class="table-flip-scroll">
                            <table class="table align-middle effects-table scrollable-table table-resp mb-0" cdkDropList [cdkDropListData]="groups" (cdkDropListDropped)="droppedGroups($event)">
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            <div class="d-flex align-items-center">
                                                <span>{{'classification.other.items' | translate}}</span>
                                            </div>
                                        </th>
                                        <th class="move-placeholder" *cdkDragPlaceholder></th>
                                        <ng-container *ngFor="let group of groups; let i = index;">
                                            <th cdkDrag class="optioned"
                                                [ngClass]="{'current-sorting': group.sorting == i}">
                                                <div *ngIf="editMode !== group.id"
                                                    class="d-flex align-items-center position-relative">
                                                    <i cdkDragHandle class="fas fa-arrows mr-1 cursor-pointer handle option"
                                                    (click)="$event.stopPropagation()"></i>
                                                    <span (click)="openEdit(group);$event.stopPropagation();"
                                                        class="cursor-pointer heading-label mx-auto">{{ group.name }}
                                                        <span class="badge badge-light">{{getGroupNumber(group.id)}}</span>
                                                    </span>
                                                    <i class="fas fa-sort mx-2 cursor-pointer sort-icon"
                                                    *ngIf="group.sortDir !== 'asc' && group.sortDir !== 'desc'"
                                                    (click)="sortTable(group.id); setSorting(groups, i)"></i>
                                                    <i class="fas fa-sort-up mx-2 cursor-pointer sort-icon-up"
                                                    *ngIf="group.sortDir == 'asc'"
                                                    (click)="sortTable(group.id); setSorting(groups, i)"></i>
                                                    <i class="fas fa-sort-down mx-2 cursor-pointer sort-icon-down"
                                                    *ngIf="group.sortDir == 'desc'"
                                                    (click)="sortTable(group.id); setSorting(groups, i)"></i>
                                                    <i class="cursor-pointer fas {{group.visible ? 'fa-eye' : 'fa-eye-slash'}}"
                                                        (click)="setVisibility(group)"></i>
                                                    <confirmation [showTrashIcon]="true" [question]="'confirm.areyousure'"
                                                                (isConfirmed)="deleteClassificationGroup($event, group);"
                                                                class=" mx-1 remove-col option">
                                                    </confirmation>
                                                </div>
                                                <div *ngIf="editMode === group.id" class="d-flex align-items-center">
                                                    <span class="position-relative cursor-pointer">
                                                        <textarea class="form-control editable-multiline" type="text" [(ngModel)]="group.name"></textarea>
                                                        <i class="fas fa-check btn-xs btn-outline-primary btn-icon position-absolute"
                                                            (click)="editClassificationGroup(group);$event.stopPropagation();"></i>
                                                        <i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon position-absolute"
                                                            (click)="cancelEdit(group);$event.stopPropagation();"></i>
                                                    </span>
                                                </div>
                                            </th>
                                        </ng-container>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="groups?.length" class="sub-header-row">
                                        <td class="text-right align-top">
                                            <small><i class="form-text text-muted mt-0">{{"Toggle all items per group" | translate}}</i></small>
                                        </td>
                                        <ng-container *ngFor="let group of groups; let i = index;">
                                            <td class="text-center">
                                                <i id="inGroup"
                                                class="fas fa-toggle-large-on toggle__icon"
                                                [ngClass]="{
                                                    'toggle-primary': getGroupToggleState(group.id) === 'all',
                                                    'fa-toggle-third-state': getGroupToggleState(group.id) === 'partial',
                                                    'fa-flip-horizontal inactive toggle-disabled': getGroupToggleState(group.id) === 'none'
                                                }"
                                                (click)="setAllGroupValue(group.id)"></i>
                                            </td>
                                        </ng-container>
                                    </tr>
                                    <ng-container *ngFor="let row of allClassificationFields | catalogFilter: searchValue; let i = index; trackBy:trackByFn">
                                        <tr class="separator-row">
                                            <td></td>
                                            <ng-container *ngFor="let group of groups; let i = index;">
                                                <td></td>
                                            </ng-container>
                                        </tr>
                                        <tr>
                                            <td>{{row.value}}</td>
                                            <ng-container *ngFor="let group of groups; let i = index;">
                                                <td class="text-center">
                                                    <i id="inGroup"
                                                    class="fas {{getGroupValue(group.id, row.id) ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                                                    (click)="setSetGroupValue(group.id, row.id)"></i>
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </section>
                    </section>
                </div>
            </div>
            <!-- Item count indicator for Groups tab (no pagination needed - all items loaded) -->
            <div class="text-muted small mt-2" *ngIf="allClassificationFields?.length > 0">
                {{ 'Showing all' | translate }} {{allClassificationFields.length}} {{ 'items' | translate }}
            </div>
        </tab>
        <tab heading="{{ 'classification.other.translation' | translate }}">
            <div class="row mb-3">
                <div class="col-12">
                    <div class="list-search-container">
                        <i class="fas fa-search list-search-icon"></i>
                        <input class="form-control list-search-input" type="text"
                            placeholder="{{ 'Search items' | translate }}"
                            [(ngModel)]="catPageFilter"
                            (keyup)="onFilterChange()">
                        <i *ngIf="catPageFilter" (click)="clearFilter()"
                            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"></i>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 table-responsive">
                    <section class="scrollable-table-container">
                        <section class="table-flip-scroll">
                            <table class="table align-middle effects-table scrollable-table table-resp mb-0">
                                <thead class="thead-inverse">
                                    <tr>
                                        <th class="text-left">
                                            <div class="d-flex align-items-center">
                                                <span>{{'classification.other.items' | translate}}</span>
                                            </div>
                                        </th>
                                        <th *ngIf="selectedClassificationType.useCustomKey" class="text-left">
                                            {{'classification.other.key' | translate}}
                                        </th>
                                        <th *ngFor="let lan of languages; let i = index;" class="text-left">
                                            {{ lan.code | translate}}</th>
                                        <th></th>
                                    </tr>
                                    <tr class="separator-header">
                                        <th *ngIf="selectedClassificationType.useCustomKey"></th>
                                        <th></th>
                                        <th *ngFor="let lan of languages; let i = index;" class="text-left"></th>
                                        <th></th>
                                    </tr>
                                    
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let row of classificationFields; let i = index; trackBy:trackByFn">
                                        <tr class="separator-row">
                                            <td></td>
                                            <td *ngIf="selectedClassificationType.useCustomKey"></td>
                                            <td *ngFor="let lan of languages; let i = index;"></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle">
                                                {{row.value}}
                                            </td>
                                            <td *ngIf="selectedClassificationType.useCustomKey" class="align-middle" style="width:15%">
                                                {{row.key}}
                                            </td>
                                            <td *ngFor="let lan of languages; let i = index;">
                                                <input class="form-control" name="translation" type="text"
                                                    [ngModel]="getTranslation(lan.code, row.id)"
                                                    (ngModelChange)="setTranslation($event, lan.code, row.id)"
                                                    (focusout)="updateClassificationField(row);">
                                            </td>
                                            <td></td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </section>
                    </section>
                </div>
            </div>
            <div class="app-pagination d-flex align-items-center justify-content-between"
                 *ngIf="fieldsAllItems > pageSizeOptions[0]">
                <span class="text-muted small">
                    {{ 'Rows per page:' | translate }}
                    <select style="border: none; background: transparent; color: inherit; font: inherit; cursor: pointer; padding: 2px 0; outline: none;"
                            [(ngModel)]="fieldsPageSize"
                            (ngModelChange)="onPageSizeChange()">
                        <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt">{{opt}}</option>
                        <option [ngValue]="PAGE_SIZE_ALL">{{ 'All' | translate }}</option>
                    </select>
                </span>
                <ul class="pagination mb-0" *ngIf="fieldsAllItems > fieldsPageSize">
                    <li class="page-item" *ngIf="fieldsPage > 1">
                        <a class="page-link" (click)="goToPage(1)">
                            <i class="fal fa-angle-double-left"></i>
                        </a>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage > 1">
                        <a class="page-link" (click)="goToPage(fieldsPage - 1)">
                            <i class="fal fa-angle-left"></i>
                        </a>
                    </li>
                    <li
                        *ngFor="let p of getPageNumber()"
                        class="page-item"
                        [ngClass]="{'hidden': (p !== fieldsPage)}">
                        <span class="page-link disabled" disabled>
                        <b>{{p}}</b> of {{getPageNumber()[(getPageNumber().length - 1)]}}
                        </span>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage <= (getPageNumber().length-1)">
                        <a class="page-link" (click)="goToPage(fieldsPage + 1)">
                            <i class="fal fa-angle-right"></i>
                        </a>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage <= getPageNumber()[(getPageNumber().length - 2)]">
                        <a class="page-link" (click)="goToPage(getPageNumber()[(getPageNumber().length - 1)])">
                            <i class="fal fa-angle-double-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </tab>
        <tab *ngIf="!isRejectionCatalogs">
            <ng-template tabHeading>
                {{ 'classification.other.externalIDs' | translate }} ({{externalids?.length}})
            </ng-template>
            <div class="row mb-3">
                <div class="col-8 pr-1">
                    <div class="list-search-container">
                        <i class="fas fa-search list-search-icon"></i>
                        <input class="form-control list-search-input" type="text"
                            placeholder="{{ 'Search items' | translate }}"
                            [(ngModel)]="catPageFilter"
                            (keyup)="onFilterChange()">
                        <i *ngIf="catPageFilter" (click)="clearFilter()"
                            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"></i>
                    </div>
                </div>
                <div class="col-4 pl-1">
                    <div class="list-search-container">
                        <input class="form-control list-search-input" type="text"
                            placeholder="{{ 'Externalid name' | translate }}"
                            [(ngModel)]="externalidValue">
                        <i *ngIf="externalidValue" (click)="externalidValue=''"
                            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"></i>
                        <a (click)="addNewClassificationExternalid()"
                            class="btn btn-sm btn-primary mr-1 {{ externalidValue && externalidValue.length >= 2 ? '' : 'disabled' }}">{{'Add' | translate }}</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">    
                    <section class="scrollable-table-container">
                        <section class="table-flip-scroll">
                            <table class="table align-middle effects-table scrollable-table table-resp mb-0">
                                <thead>
                                    <tr cdkDropList
                                    [cdkDropListData]="externalids"
                                    (cdkDropListDropped)="droppedExternalid($event)">
                                        <th class="text-left">
                                            <div class="d-flex align-items-center">
                                                <span>{{'classification.other.items' | translate}}</span>
                                            </div>
                                        </th>
                                        <ng-container *ngFor="let externalid of externalids; let i = index;">
                                            <th cdkDrag [ngClass]="{'current-sorting': externalid.sorting == i}" class="optioned">
                                                <div *ngIf="editMode !== externalid.id"
                                                    class="d-flex align-items-center position-relative">
                                                    <i class="fas fa-arrows mr-1 cursor-pointer handle option"
                                                        (click)="$event.stopPropagation()"></i>
                                                    <span (click)="openEdit(externalid);$event.stopPropagation();"
                                                        class="cursor-pointer heading-label mx-auto">{{ externalid.name }}</span>
                                                    <i class="fas fa-sort mx-2 cursor-pointer sort-icon"
                                                        *ngIf="externalid.sortDir !== 'asc' && externalid.sortDir !== 'desc'"
                                                        (click)="sortTableEIDs(externalid.id); setSorting(externalids, i)"></i>
                                                    <i class="fas fa-sort-up mx-2 cursor-pointer sort-icon-up"
                                                        *ngIf="externalid.sortDir == 'asc'"
                                                        (click)="sortTableEIDs(externalid.id); setSorting(externalids, i)"></i>
                                                    <i class="fas fa-sort-down mx-2 cursor-pointer sort-icon-down"
                                                        *ngIf="externalid.sortDir == 'desc'"
                                                        (click)="sortTableEIDs(externalid.id); setSorting(externalids, i)"></i>

                                                    <confirmation [showTrashIcon]="true" [question]="'confirm.areyousure'"
                                                        (isConfirmed)="deleteClassificationExternalid($event, externalid);$event.stopPropagation();"
                                                        class="ml-1 remove-col option">
                                                    </confirmation>
                                                </div>
                                                <div *ngIf="editMode === externalid.id" class="d-flex align-items-center">
                                                    <span class="position-relative cursor-pointer">
                                                        <textarea class="form-control editable-multiline" type="text" [(ngModel)]="externalid.name"></textarea>
                                                        <i class="fas fa-check btn-xs btn-outline-primary btn-icon position-absolute"
                                                            (click)="editClassificationExternalid(externalid);$event.stopPropagation();"></i>
                                                        <i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon position-absolute"
                                                            (click)="cancelEdit(externalid);$event.stopPropagation();"></i>
                                                    </span>
                                                </div>
                                            </th>
                                        </ng-container>
                                        <th></th>
                                    </tr>
                                    <tr class="separator-header">
                                        <th></th>
                                        <ng-container *ngFor="let externalid of externalids; let i = index;"><th></th></ng-container>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let row of classificationFields | filterBy: searchTextFilterObject; let i = index; trackBy:trackByFn">
                                        <tr class="separator-row">
                                            <td></td>
                                            <ng-container *ngFor="let externalid of externalids; let i = index;"><td></td></ng-container>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>{{row.value}}</td>
                                            <ng-container *ngFor="let externalid of externalids; let i = index;">
                                                <td><input  class="form-control" type="text"
                                                    (blur)="setSetExternalidValue($event, externalid.id, row.id)" value="{{getExtenalidValue(externalid.id, row.id)}}"/></td>
                                            </ng-container>
                                            <td></td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </section>
                    </section>
                </div>
            </div>
            <div class="app-pagination d-flex align-items-center justify-content-between"
                 *ngIf="fieldsAllItems > pageSizeOptions[0]">
                <span class="text-muted small">
                    {{ 'Rows per page:' | translate }}
                    <select style="border: none; background: transparent; color: inherit; font: inherit; cursor: pointer; padding: 2px 0; outline: none;"
                            [(ngModel)]="fieldsPageSize"
                            (ngModelChange)="onPageSizeChange()">
                        <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt">{{opt}}</option>
                        <option [ngValue]="PAGE_SIZE_ALL">{{ 'All' | translate }}</option>
                    </select>
                </span>
                <ul class="pagination mb-0" *ngIf="fieldsAllItems > fieldsPageSize">
                    <li class="page-item" *ngIf="fieldsPage > 1">
                        <a class="page-link" (click)="goToPage(1)">
                            <i class="fal fa-angle-double-left"></i>
                        </a>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage > 1">
                        <a class="page-link" (click)="goToPage(fieldsPage - 1)">
                            <i class="fal fa-angle-left"></i>
                        </a>
                    </li>
                    <li
                        *ngFor="let p of getPageNumber()"
                        class="page-item"
                        [ngClass]="{'hidden': (p !== fieldsPage)}">
                        <span class="page-link disabled" disabled>
                        <b>{{p}}</b> of {{getPageNumber()[(getPageNumber().length - 1)]}}
                        </span>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage <= (getPageNumber().length-1)">
                        <a class="page-link" (click)="goToPage(fieldsPage + 1)">
                            <i class="fal fa-angle-right"></i>
                        </a>
                    </li>
                    <li class="page-item" *ngIf="fieldsPage <= getPageNumber()[(getPageNumber().length - 2)]">
                        <a class="page-link" (click)="goToPage(getPageNumber()[(getPageNumber().length - 1)])">
                            <i class="fal fa-angle-double-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </tab>
    </tabset>
</div>
